// @flow

const FACTOR = 2.2046;

const normalize = n => {
  const digitsAfterDot = String(n).split('.')[1];

  return digitsAfterDot && digitsAfterDot.length > 2 ? n.toFixed(2) : n;
};

export const convertKgToLbs = (kg: number) => normalize(kg * FACTOR);
export const convertLbsToKg = (lbs: number) => normalize(lbs / FACTOR);
